/**
 * Studio menu direction (doc 120 · D16a).
 *
 * The owner's ruling: "All dropdown menus should go down." Radix positions a
 * popper with floating-ui; when the content does not fit below its trigger the
 * `flip` middleware moves it above, which is what sends a tall menu off the top
 * of the screen. Radix has no "never flip" switch and no CSS surface for
 * placement, so the choice is made here.
 *
 * Mechanism: `avoidCollisions={false}`, which removes `shift` and `flip` from
 * the middleware array, plus `side="bottom"`. The `size` middleware is NOT
 * gated on `avoidCollisions`, so Radix still publishes
 * `--radix-popper-available-height` for the space below the trigger, and the
 * content keeps its `max-h-[…available-height] overflow-y-auto` cap — a menu
 * that cannot fit below scrolls inside itself instead of leaving the viewport.
 * That is the "cap height, scroll inside" resolution, not "push it off the
 * bottom".
 *
 * Rejected mechanism, recorded so nobody tries it again: padding the collision
 * boundary's top (`collisionPadding: {top: 9999}`) does make `flip`'s `bestFit`
 * always choose `bottom` — `flip` only reads `overflow[side]` on the main axis —
 * but `size` computes
 *   maximumClippingHeight = height - overflow.top - overflow.bottom
 * from the same padded overflow (@floating-ui/core, `size`), so
 * `--radix-popper-available-height` comes out at about -9999px and every menu
 * collapses to zero height.
 *
 * Trade-off accepted: with collisions off there is no horizontal `shift`
 * either, so a menu whose trigger sits within half a menu-width of the viewport
 * edge could overflow sideways. Every menu on seven routes is measured for
 * exactly that (see docs/app-map/studio/fixes/chrome-menus.md); any that does
 * gets an `align` of its own rather than the shift back.
 *
 * Classic is untouched: with `studio` false these return `undefined`, which is
 * what Radix already receives today, so not one byte of the classic tree moves.
 */

export function studioMenuSide(studio, side) {
  return studio ? 'bottom' : side;
}

export function studioAvoidCollisions(studio, avoidCollisions) {
  return studio ? false : avoidCollisions;
}
